/**
 * Recordings applicability — is the county-clerk filing record meaningful
 * for this deal?
 *
 * A recording exists because an instrument assigning an existing lease got
 * filed with the county clerk. That happens when Warwick takes an assignment
 * (`deal_type = 'ASSIGNMENT'`) and when it assigns interest away — a
 * divestiture, which the schema records on `deals.deal_category`
 * ('ACQUISITION' | 'DIVESTITURE'), not on `deal_type`. A new lease, deed,
 * option or surface agreement has no assignment to record, so the Recordings
 * tab is hidden for those.
 *
 * Both fields are checked against the same vocabulary so that adding
 * DIVESTITURE to the `deals.deal_type` pick list (admin-editable) would also
 * qualify without a code change.
 */
const norm = (v) => String(v ?? "").trim().toUpperCase();

export const RECORDING_DEAL_TYPES = new Set(["ASSIGNMENT", "DIVESTITURE"]);

export const isRecordingsApplicable = (deal) =>
  RECORDING_DEAL_TYPES.has(norm(deal?.deal_type)) ||
  RECORDING_DEAL_TYPES.has(norm(deal?.deal_category));

export default isRecordingsApplicable;
